


















































import { Vue, Component } from 'vue-property-decorator'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { APIRole } from '../../models/api/role.model'

@Component({
    components: {
        ConfirmDialog
    }
})
export default class UserRolesForm extends Vue {
    loading = true
    cardTitle = ''

    buttonLoading = false

    formData: {[key: string]: string} = {}
    formValid = false
    formRules = {}
    formModel: { roles: APIRole[]; userRoles: APIRole[] } = {
        roles: [],
        userRoles: []
    }

    async mounted () {
        this.cardTitle = 'Edit User Roles'
        await this.getUserById()
        await this.getRoles()
    }

    getUserById () {
        this.loading = true
        return new Promise(resolve => {
            if (!this.$route.params.id) {
                this.$store.commit('reportError', { code: 1000, message: 'Error, not id sended in route params :(' })
                this.loading = false
                return
            }

            this.$store.dispatch('getUserById', this.$route.params.id)
                .then(resp => {
                    if (resp?.status === 200) {
                        this.formModel.userRoles = JSON.parse(JSON.stringify(this.$store.state.UsersStore.userForm.roles))
                        this.loading = false
                        resolve()
                    }
                })
        })
    }

    getRoles () {
        this.loading = true
        return new Promise(resolve => {
            this.$store.dispatch('getRoles')
                .then(resp => {
                    if (resp?.status === 200) {
                        this.formModel.roles = JSON.parse(JSON.stringify(this.$store.state.RolesStore.roles))

                        this.formModel.roles.forEach(a => {
                            if (this.formModel.userRoles && this.formModel.userRoles.find(b => b.roleId === a.roleId)) {
                                a.active = true
                            }
                        })

                        this.loading = false
                        resolve()
                    }
                })
        })
    }

    async validateForm () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return

        const addedRoles: APIRole[] = []
        const removedRoles: APIRole[] = []

        let changed = false

        this.formModel.roles.forEach(role => {
            if (role.active && this.formModel.userRoles && !this.formModel.userRoles.find(formRole => formRole.roleId === role.roleId)) {
                addedRoles.push(role)
            }
            if (!role.active && this.formModel.userRoles && this.formModel.userRoles.find(formRole => formRole.roleId === role.roleId)) {
                removedRoles.push(role)
            }
        })

        this.buttonLoading = true

        if (addedRoles.length > 0) {
            await this.$store.dispatch(
                'addRoleToUser',
                {
                    userId: this.$route.params.id,
                    roles: addedRoles
                })
                .then(async (resp) => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        changed = true
                        this.buttonLoading = false
                    }
                })
        }
        if (removedRoles.length > 0) {
            await this.$store.dispatch(
                'removeRoleToUser',
                {
                    userId: this.$route.params.id,
                    roles: removedRoles
                })
                .then(async (resp) => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        changed = true
                        this.buttonLoading = false
                    }
                })
        }

        if (changed) {
            this.getUserById()
            this.getRoles()
        }
    }
}
